import { render } from "./AppAbout.vue?vue&type=template&id=511e553e&scoped=true"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"

import "./AppAbout.vue?vue&type=style&index=0&id=511e553e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\petr.hric\\Desktop\\MyDrive\\web\\mkosmeo\\mkosmeo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511e553e"]])

export default __exports__